jQuery(window).click(function(e) {
  let elClass = jQuery(e.target).attr("class");
  let searchInput = jQuery('.header-desk-search .search__input.field__input').val();
  jQuery('#bc-instant-search').css('opacity','0');
  
  //console.log(elClass);
  if( jQuery(e.target).hasClass('boost-sd__button-text-x') ) {
    jQuery('#empty-search-container').addClass('hidden');
  } else {    
    if (jQuery(e.target).hasClass('search__input') || jQuery(e.target).hasClass("empty-search-container") || jQuery(e.target).parents().hasClass("empty-search-container") ) {
    //console.log(searchInput);
      if( searchInput == "" ) { 
        //console.log(searchInput);
        setTimeout(() => {
          setSearchWidth();
          jQuery('#empty-search-container').removeClass('hidden');
        }, 50);
      } else {
        jQuery('#bc-instant-search').css('opacity','1');
        jQuery('#empty-search-container').addClass('hidden');
      }
    } else {  
      //console.log(elClass);
      jQuery('#empty-search-container').addClass('hidden');
    }
  }
});

jQuery(window).on('change input', function(e) {
  let elClass = jQuery(e.target).attr("class");
  if( jQuery(e.target).hasClass('search__input field__input') ) {    
    //console.log(elClass);
    var searchInput = jQuery(e.target).val();
    //console.log(searchInput);
    if( searchInput == "" ) { 
        jQuery('#bc-instant-search').css('opacity','0');
        setTimeout(() => {
          setSearchWidth();
          jQuery('#empty-search-container').removeClass('hidden');
        }, 50);
    } else {
      
      jQuery('#empty-search-container').addClass('hidden');
      jQuery('#bc-instant-search').css('opacity','1');
    }
  }
});

function setSearchWidth() {
  
  const searchInput = document.querySelector('.header-desk-search .search__input.field__input').getBoundingClientRect();
  const position = 'absolute';

  // + 2 px => border of input
  // + 4 px: distance from input from input autocomplete to this input
  // window.scrollY: if window has scroll Y
  const searchScroll = window.scrollY;
  let searchTop = searchInput.height + searchInput.top - 2;
  // - 20: distance from suggestion to bottom of window
  const _maxHeight = window.innerHeight - searchTop - 20;

  let _positionLeftOrRight = `left: ${searchInput.left}px`;

  // auto detect suggestion position
  if (window.innerWidth / 2 < searchInput.left) {
    _positionLeftOrRight = `right: ${window.innerWidth - searchInput.right}px`;
  }

  searchTop = searchTop + searchScroll;

  document.querySelector('#empty-search-container').setAttribute(
    'style',
    `position: ${position}; top: ${searchTop}px; ${_positionLeftOrRight}; z-index: 999999998;`
  );  
}